.item {
  cursor: pointer;
  transition:
    background-color 100ms ease-out,
    transform 100ms ease-in-out,
    opacity 100ms ease-in;
  transform: scale(0.995, 0.995);
  opacity: 0.7;
  &.selected,
  &:hover {
    opacity: 1;
    z-index: 1000;
    background-color: light-dark(
      var(--mantine-color-gray-1),
      var(--mantine-color-gray-8)
    );
    transform: scale(1, 1);
  }
  &.selected {
    background-color: var(--mantine-color-gray-0);
    box-shadow:
      inset 0 1px 0 0 var(--mantine-color-gray-1),
      inset 0 -1px 0 0 var(--mantine-color-gray-1);
  }
}
